/* eslint-disable no-unused-vars, no-useless-constructor*/
import React from 'react';
import Fade from 'react-reveal/Fade';
import { Nav, NavItem } from 'react-bootstrap';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ActionCreator from '../../../../action/ActionCreator';

import BaseComponent from '../../../../panther/components/base/BaseComponent';

import styles from './MicrositeNavigation.css';

class MicrositeNavigation extends BaseComponent {
    constructor() {
        super();
    }

    changeView(view) {
        ActionCreator.viewChange(view);
        this.props.menuItemOnClick();
    }

    render() {
        let classes = classNames(
            'microsite-nav navbar-right', {
                'open': this.props.mobileNavOpen
            },
            this.props.className
        );
        let content = this.renderNavItems();

        return (
            <Fade right distance="30px">
                <Nav className={classes} id="myNavbar">
                    {content}
                </Nav>
            </Fade>
        );
    }

    /**
     * Get items for navigation from data
     * @returns {Array}
     */
    renderNavItems(){
        let content  = [];
        let sections = this.props.sections;

        sections.map(section => {
           if (section.data.navLabel) {
               content.push(<NavItem
                   onClick={this.changeView.bind(this, section.data.id)}
                   key={section.data.id}
               >
                   {section.data.navLabel}
               </NavItem>);
           }
           return content;
        });

        return content;
    }
}

MicrositeNavigation.propTypes = {
    mobileNavOpen: PropTypes.bool,
    menuItemOnClick: PropTypes.func,
    sections: PropTypes.array
};

export default MicrositeNavigation;